import React from 'react';
import { motion } from 'framer-motion';
export function OldSolutionsSection() {
  const dangerousHours = ['11:30 p.m.', 'después de dos copas', 'después de ver una historia', 'cuando recuerdas un audio', 'cuando aparece el "¿y si solo le digo…?"'];
  return <section className="bg-[#0D0D0D]" style={{
    paddingTop: 'var(--space-section)',
    paddingBottom: 'var(--space-section)',
    paddingLeft: 'var(--pad-x)',
    paddingRight: 'var(--pad-x)'
  }} data-id="element-98">
      <div className="max-w-2xl mx-auto" data-id="element-99">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} data-id="element-100">
          <h2 className="fluid-3xl font-bold text-white mb-8 font-serif" data-id="element-101">
            Por qué lo que has intentado falla <br data-id="element-102" />
            <span className="text-[#9A948C] font-sans font-normal block mt-2 fluid-xl" data-id="element-103">
              (aunque seas inteligente)
            </span>
          </h2>

          <div className="flex flex-wrap gap-4 mb-10 font-serif italic text-[#F5F0EB]/60 fluid-xl" data-id="element-104">
            <span className="border-b border-[#A52422]/40 pb-1" data-id="element-105">
              "Distráete."
            </span>
            <span className="border-b border-[#A52422]/40 pb-1" data-id="element-106">
              "Sal con amigas."
            </span>
            <span className="border-b border-[#A52422]/40 pb-1" data-id="element-107">
              "Haz contacto cero."
            </span>
          </div>

          <p className="fluid-lg text-[#F5F0EB]/90 mb-8 leading-relaxed" data-id="element-108">
            Todo eso suena bien… hasta que llega la{' '}
            <span className="text-[#A52422] font-semibold" data-id="element-109">hora peligrosa</span>
            :
          </p>

          <ul className="space-y-3 mb-10 pl-4 border-l border-[#333]" data-id="element-110">
            {dangerousHours.map((item, index) => <li key={index} className="text-[#9A948C] fluid-lg" data-id="element-111">
                {item}
              </li>)}
          </ul>

          <p className="fluid-xl text-white font-medium" data-id="element-112">
            Ahí no necesitas motivación. <br data-id="element-113" />
            <span className="text-[#A52422] font-serif italic mt-2 block fluid-2xl" data-id="element-114">
              Necesitas un protocolo.
            </span>
          </p>

          <p className="mt-4 text-[#F5F0EB]/80 fluid-base" data-id="element-115">
            Un camino que sepas seguir incluso con el pulso temblando.
          </p>
        </motion.div>
      </div>
    </section>;
}